import React from 'react'
import {Button} from '../../../components/library/buttons'
import {IconName} from '../../../components/library/icon/icon'
import {
  StepperActions,
  StepperBody,
  StepperContain,
  StepperContent,
  StepperMessage,
  StepperTitle,
  StepperWrap,
  StepperMedia
} from '../../../components/library/stepper/stepper'

export const Finish = ({
  message,
  icon,
  title,
  onClick,
  buttonText
}: {
  message: string
  icon: IconName
  title: string
  onClick(): void
  buttonText: string
}) => {
  return (
    <StepperWrap center={true}>
      <StepperBody>
        <StepperContent>
          <StepperMedia icon={icon}></StepperMedia>
          <StepperTitle>{title}</StepperTitle>
          <StepperMessage>{message}</StepperMessage>
          <StepperContain>
            <StepperActions>
              <Button size="large" onClick={onClick}>
                {buttonText}
              </Button>
            </StepperActions>
          </StepperContain>
        </StepperContent>
      </StepperBody>
    </StepperWrap>
  )
}
